import {createRef, KeyboardEvent, PureComponent} from 'react';

import './Elt.css';
import { asChar, char } from './serialization';

type EltProps = {
  className? : string

  onFocus? : (coord : string) => void;

  coord? : string;
  onChange? : (coord : string, c : char) => boolean;

  children: string;
}

type EltState = {
  warning : boolean;
}

class Elt extends PureComponent<EltProps, EltState> {
  static defaultProps : EltProps = {children: ""};

  private divRef = createRef<HTMLDivElement>();

  state = {
    warning: false,
  }

  constructor(props: EltProps) {
    super(props);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
  }

  private handleKeyDown(event: KeyboardEvent<HTMLDivElement>) {
    if (!this.props.onChange || !this.props.coord) return;
    if (event.altKey || event.ctrlKey || event.metaKey) return;

    let c : char|undefined;
    if (event.key === "Backspace") {
      c = "";
    } else {
      c = asChar(event.key.toUpperCase());
    }

    if (c === undefined) return;

    if (!this.props.onChange(this.props.coord, c)) {
      this.setState({warning: true});
    }
  }

  private handleKeyUp(event: KeyboardEvent<HTMLDivElement>) {
    if (this.state.warning) {
      this.setState({warning: false});
    }
  }

  private handleFocus() {
    if (!this.props.onFocus || !this.props.coord) return;
    this.props.onFocus(this.props.coord);
  }

  public focus() {
    this.divRef.current?.focus();
  }

  get className() : string {
    let ret = ["Elt"];

    if (this.props.className) ret.push(this.props.className)
    if (this.state.warning) ret.push("warning")
    if (this.props.children.match(/\d/)) ret.push("numeric")

    return ret.join(" ");
  }

  render() : JSX.Element {
    console.log("rendering elt");

    return (
      <div
        className={this.className}
        ref={this.divRef}
        onFocus={this.handleFocus}
        onKeyDown={this.handleKeyDown}
        onKeyUp={this.handleKeyUp}
        tabIndex={-1}
      >
        {this.props.children}
      </div>
    );
  }
}

export default Elt;